import type { ReactNode } from 'react'
import { CatchBoundary } from '@tanstack/react-router'

const renderNothing = () => null

export function IsolatedContribution({ children }: { children: ReactNode }) {
  return (
    <CatchBoundary getResetKey={() => 0} errorComponent={renderNothing}>
      {children}
    </CatchBoundary>
  )
}
